module.exports = __webpack_public_path__ + "static/media/medapp.89d9b100.mp4";